import {Tabs} from '@mantine/core';
import {cn} from '../../../../../../lib/classname';

type TabButtonProps = {
  value: string;
  active: boolean;
  onClick: () => void;
  name: string;
};

export const TabButton: React.FC<TabButtonProps> = ({
  value,
  active,
  onClick,
  name,
}) => (
  <Tabs.Tab
    className={cn(
      'transition-all duration-700 relative z-20 w-1/2 flex justify-center items-center px-0 py-2',
      active ? 'text-white' : 'text-black',
    )}
    value={value}
    onClick={onClick}
  >
    <span className="text-base font-bold">{name}</span>
  </Tabs.Tab>
);
